enum SignatureConfirmation {
  STANDARD = 'STANDARD',
  ADULT = 'ADULT',
  CERTIFIED = 'CERTIFIED',
  INDIRECT = 'INDIRECT',
  CARRIER_CONFIRMATION = 'CARRIER_CONFIRMATION',
}

export default SignatureConfirmation;
